// Build metadata is read off `window` rather than from `process.env`, where
// DefinePlugin would inline it into the bundle. Inlined values are baked into
// cached modules, so webpack has to include them in its persistent-cache
// version hash — and since the timestamp and commit change on every build, that
// discarded the whole cache each time. index.html gets the same values from
// InterpolateHtmlPlugin, which rewrites an asset instead of a module and so
// costs nothing. See `cache.version` in config/webpack.config.js.
declare global {
  interface Window {
    __WS_BUILD__?: {
      timestamp?: string;
      commit?: string;
    };
  }
}

const injected =
  typeof window === "undefined" ? undefined : window.__WS_BUILD__;

// The process.env fallbacks only apply where index.html is not the entry point,
// e.g. jest.
export const BUILD_TIMESTAMP =
  injected?.timestamp || process.env.REACT_APP_BUILD_TIMESTAMP || "";

export const BUILD_COMMIT =
  injected?.commit || process.env.REACT_APP_GIT_LATEST_COMMIT || "";
